import AutocompleteMultiSelect from './AutocompleteMultiSelect';

export default AutocompleteMultiSelect;
